
export default {
  name: 'CartQuantityStepper',

  props: {
    value: {
      type: Number,
      default: 1,
    },

    min: {
      type: Number,
      default: 1,
    },

    max: {
      type: Number,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      current: this.value,
    }
  },

  computed: {
    atMax() {
      return this.max !== null && this.current >= this.max
    },
  },

  watch: {
    value(quantity) {
      this.current = quantity
    },
  },

  methods: {
    bounded(quantity) {
      return Math.min(
        this.max === null ? Infinity : this.max,
        Math.max(this.min, quantity)
      )
    },

    step(delta) {
      const next = this.bounded(this.current + delta)

      if (next === this.current) {
        return
      }

      this.current = next
      this.$emit('change', next)
    },

    type(value) {
      const digits = String(value).replace(/\D/g, '')

      this.current = digits === '' ? '' : Number(digits)

      if (digits === '') {
        return
      }

      const next = this.bounded(Number(digits))

      if (next !== this.value) {
        this.$emit('change', next)
      }
    },

    normalize() {
      const next = this.bounded(Number(this.current) || this.min)

      this.current = next

      if (next !== this.value) {
        this.$emit('change', next)
      }
    },
  },
}
